<template>
    <div class="flex flex-row items-start py-2">
        <div class="iconBox">
            <img alt="" class="inset-0" :src="image">
        </div>
        <div class="self-center  ml-4">
            <h2 class="">{{ text }}</h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WhatDoWeDoItem',
    props: {
        data: Object,
    },
    computed: {
        text() {
            return this.data.text;
        },
        image() {
            return this.data.image;
        },
    },
};
</script>

<style scoped>

</style>
